export const listQuickWords = async apiCall => {
  return await apiCall("/quickword/system/schema/list", "GET");
};

export const getQuickWord = async (apiCall, id, version) => {
  const request = { id, version };
  return await apiCall("/quickword/system/schema/get", "POST", request);
};

export const upsertQuickWord = async (apiCall, schema) => {
  const request = { schema };
  return apiCall("/quickword/system/schema/upsert", "POST", request);
};

export const publishQuickWord = async (apiCall, id) => {
  const request = { id };
  return await apiCall("/quickword/system/schema/publish", "POST", request);
};

export const deleteQuickWord = async (apiCall, id, version) => {
  const request = { id, version };
  return await apiCall("/quickword/system/schema/delete", "POST", request);
};
